import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "../../pages/Auth/hooks/useAuth";

export default function PrivateRoute({ children }) {
  const { user, sessionExpired, system_id } = useAuth();
  console.log("🚀 ~ PrivateRoute ~ system_id:", system_id);

  if ((!user || !system_id) && sessionExpired) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
